import React from "react";
import "./mainDashboard.css"
export const CustomSkeleton = () => {
    return (
        <div>
        {/* Skeleton for budgetMain */}
        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
          <div className="skeleton" style={{ width: '50%', height: '200px' }}></div>
          <div className="skeleton" style={{ width: '50%', height: '200px' }}></div>
        </div>
  
        {/* Skeleton for SavingMain */}
        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
          <div className="skeleton" style={{ width: '50%', height: '200px' }}></div>
          <div className="skeleton" style={{ width: '50%', height: '200px' }}></div>
        </div>
  
        {/* Skeleton for GoalsMain */}
        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
          <div className="skeleton" style={{ width: '50%', height: '200px' }}></div>
          <div className="skeleton" style={{ width: '50%', height: '200px' }}></div>
        </div>
  
        {/* Skeleton for single component */}
        <div style={{ marginTop: '1rem' }}>
          <div className="skeleton" style={{ width: '100%', height: '200px' }}></div>
        </div>
      </div>
    );
  };